import { useCallback, useRef, useState } from 'react';

import type {
  ScrollState,
  SliderHandle,
} from '@/core/tamagoshi/Carousel/components/Slider/Slider';

interface VisibilityState {
  leftVisible: boolean;
  rightVisible: boolean;
  position: number;
  max: number;
}

interface UsePlaylistFilter {
  ref: React.RefObject<SliderHandle>;
  onScrollChange: (state: ScrollState) => void;
  visibilityState: VisibilityState;
  onControlClick: (value: 'right' | 'left') => void;
}

export const usePlaylistFilter = (): UsePlaylistFilter => {
  const [visibilityState, setVisibilityState] = useState({
    leftVisible: false,
    rightVisible: true,
    position: 0,
    max: 1,
  });
  const ref = useRef<SliderHandle>(null);

  const onScrollChange = useCallback(
    (sliderState: ScrollState) => {
      const leftVisible =
        sliderState.position > sliderState.min && sliderState.index !== 0;
      const rightVisible = sliderState.position < sliderState.max;
      if (
        sliderState.position !== visibilityState.position ||
        sliderState.max !== visibilityState.max
      ) {
        setVisibilityState({
          leftVisible,
          rightVisible,
          position: sliderState.position,
          max: sliderState.max,
        });
      }
    },
    [visibilityState.max, visibilityState.position],
  );

  const onControlClick = useCallback(
    (direction: 'right' | 'left') => ref.current?.scrollTo(direction),
    [],
  );

  return {
    ref,
    visibilityState,
    onScrollChange,
    onControlClick,
  };
};
